/*
 * Settings APIs
 */
import client from './client'

export default {
  /** Featured Advertisers 列表 */
  getFeaturedAdvertiserList: () => {
    return client.get('advertiser/featured').then((res) => res.data)
  },
  /** 更新某个 Position 的 Featured Advertiser */
  updateFeaturedAdvertiser: (data) => {
    return client.post(`advertiser/featured/${data.id}`, {
      advertiserId: data.advertiserId,
    }).then((res) => res.data)
  },
  /** 获取广告商建议列表 */
  getAdvertiserSuggestionList: (data) => {
    return client.get('advertiser/suggestion/list', {
      params: data,
    }).then((res) => res.data)
  },

}
